import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=b856a7d8&scoped=true&"
import script from "./Offer.vue?vue&type=script&lang=js&"
export * from "./Offer.vue?vue&type=script&lang=js&"
import style0 from "./Offer.vue?vue&type=style&index=0&id=b856a7d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b856a7d8",
  null
  
)

export default component.exports